<template>
    <div v-if="disease">
        <b-modal
            v-model="show_modal_local"
            :title="'Реактирование заболевания'"
            class="modal-primary"
            size="xl"
            ok-variant="primary"
            @hide.prevent
            @ok="handleOk"
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >
            <div class="row">
                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Наименование заболевания"
                        :invalid-feedback="veeErrors.first('title')"
                        :state="validateState('title')"
                    >
                        <input
                            class="form-control"
                            type="text"
                            v-model="disease.title"
                            v-validate="{ required:true, max:200 }"
                            name="title"
                            data-vv-as="'Наименование заболевания'"
                            placeholder="Укажите наименование заболевания"
                            :state="validateState('title')"
                        >
                    </b-form-group>
                </div>

                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Группа заболеваний"
                    >
                        <v-select
                            :options="disease_categories"
                            v-model="disease.t_diseases_section_id"
                            placeholder="Группа заболеваний"
                            label="title"
                            :reduce="x=>x.id"
                        ></v-select>
                    </b-form-group>
                </div>

                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Краткое описание"
                        :invalid-feedback="veeErrors.first('description')"
                        :state="validateState('description')"
                    >
                        <input
                            class="form-control"
                            type="text"
                            v-model="disease.description"
                            v-validate="{ max:300 }"
                            name="description"
                            data-vv-as="'Краткое описание'"
                            placeholder="Укажите краткое описание (до 300 символов)"
                            :state="validateState('description')"
                        >
                    </b-form-group>
                </div>

                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Ключевые слова"
                        :invalid-feedback="veeErrors.first('keywords')"
                        :state="validateState('keywords')"
                    >
                        <input
                            class="form-control"
                            type="text"
                            v-model="disease.keywords"
                            v-validate="{ max:100 }"
                            name="keywords"
                            data-vv-as="'Ключевые слова'"
                            placeholder="можно забить и ничего не писать здесь"
                            :state="validateState('keywords')"
                        >
                    </b-form-group>
                </div>

                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Уникальный идентификатор"
                        description="поле формируется автоматически"
                    >
                        <input
                            class="form-control"
                            type="text"
                            v-model="disease.hurl"
                            name="hurl"
                            readonly
                        >
                    </b-form-group>
                </div>

                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Картинка для страницы"
                        :invalid-feedback="veeErrors.first('image')"
                        :state="validateState('image')"
                        description="надо сделать нормальную загрузку картинки"
                    >
                        <input
                            class="form-control"
                            type="text"
                            v-model="disease.image"
                            v-validate="{ max:100 }"
                            name="image"
                            data-vv-as="'Картинка для страницы'"
                            placeholder="здесь надо печатаь URL"
                            :state="validateState('image')"
                        >
                    </b-form-group>
                </div>

                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Описание термина заболевания"
                        :invalid-feedback="veeErrors.first('definition')"
                        :state="validateState('definition')"
                    >
                        <textarea
                            class="form-control"
                            v-model="disease.definition"
                            v-validate="{ max:10000 }"
                            name="definition"
                            data-vv-as="'Описание термина заболевания'"
                            :state="validateState('definition')"
                        ></textarea>
                    </b-form-group>
                </div>

                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Причины возникновения заболевания"
                        :invalid-feedback="veeErrors.first('cause')"
                        :state="validateState('cause')"
                    >
                        <textarea
                            class="form-control"
                            v-model="disease.cause"
                            v-validate="{ max:10000 }"
                            name="cause"
                            data-vv-as="'Причины возникновения заболевания'"
                            :state="validateState('cause')"
                        ></textarea>
                    </b-form-group>
                </div>


                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Симптомы заболевания"
                        :invalid-feedback="veeErrors.first('symptoms')"
                        :state="validateState('symptoms')"
                    >
                        <textarea
                            class="form-control"
                            v-model="disease.symptoms"
                            v-validate="{ max:10000 }"
                            name="symptoms"
                            data-vv-as="'Симптомы заболевания'"
                            :state="validateState('symptoms')"
                        ></textarea>
                    </b-form-group>
                </div>

                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Виды/формы заболевания"
                        :invalid-feedback="veeErrors.first('forms')"
                        :state="validateState('forms')"
                    >
                        <textarea
                            class="form-control"
                            v-model="disease.forms"
                            v-validate="{ max:10000 }"
                            name="forms"
                            data-vv-as="'Виды/формы заболевания'"
                            :state="validateState('forms')"
                        ></textarea>
                    </b-form-group>
                </div>


                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Стадии заболевания"
                        :invalid-feedback="veeErrors.first('stages')"
                        :state="validateState('stages')"
                    >
                        <textarea
                            class="form-control"
                            v-model="disease.stages"
                            v-validate="{ max:10000 }"
                            name="stages"
                            data-vv-as="'Стадии заболевания'"
                            :state="validateState('stages')"
                        ></textarea>
                    </b-form-group>
                </div>


                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Методы лечения заболевания"
                        :invalid-feedback="veeErrors.first('methods')"
                        :state="validateState('methods')"
                    >
                        <textarea
                            class="form-control"
                            v-model="disease.methods"
                            v-validate="{ max:10000 }"
                            name="methods"
                            data-vv-as="'Методы лечения заболевания'"
                            :state="validateState('methods')"
                        ></textarea>
                    </b-form-group>
                </div>

                <div class="col col-12 col-lg-6">
                    <b-form-group
                        label="Профилактика лечения"
                        :invalid-feedback="veeErrors.first('prophylaxis')"
                        :state="validateState('prophylaxis')"
                    >
                        <textarea
                            class="form-control"
                            v-model="disease.prophylaxis"
                            v-validate="{ max:10000 }"
                            name="prophylaxis"
                            data-vv-as="'Профилактика лечения'"
                            :state="validateState('prophylaxis')"
                        ></textarea>
                    </b-form-group>
                </div>

            </div>


            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()">
                    Сохранить
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions';
    import { functions_hotel_data } from '@/functions_hotel_data';
    import { functions_period } from '@/functions_period';

    export default {
        name: 'DiseaseEditDialog',
        mixins: [functions, functions_hotel_data],
        data: function () {
            return {
            };
        },
        model: {
            prop: "disease_id",
            event: "hide"
        },
        props: {
            disease_id: Number,
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                this.$emit("hide", 0);
            },
            handleOk: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.saveDisease(function (self) {
                            self.$emit("changed", self.disease.id);
                            self.$emit("hide", 0);
                        }, this);
                    }
                });
            },
        },
        computed: {
            show_modal_local: {
                get: function () {
                    return this.is(this.disease);
                },
                set: function (newValue) {}
            },
        },
        created: function() {
            this.loadDisease(this.disease_id);
            this.loadDiseaseCategories();
        },
    }
</script>
